import UserManagementCardActions from './UserManagementCardActions';

export default UserManagementCardActions;
